export default {
    zh: {
        // SEO Meta
        metaTitle: 'Nano Banana Pro 人工智能图像生成器 ',
        metaDescription:
            'Nano Banana Pro（Gemini 3.0 Pro Image）是 Google 推出的全球首个“推理图像引擎”，不仅能绘画，更能理解物理规律与空间逻辑。作为 Nano Banana 的旗舰升级版，它能像人类一样“思考”和“规划”场景，生成前所未有的逻辑一致性、完美文字和超高分辨率的视觉作品。现在就可以在 微鲤AI 图像生成器中免费试用 Nano Banana Pro。',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, 图像生成, AI 绘画, 人工智能, 图像编辑, 角色一致性',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro 人工智能图像生成器',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, 图像生成, AI 绘画, 人工智能, 图像编辑, 角色一致性',

        // Core Features Section
        coreFeaturesTitle: 'Nano Banana Pro 核心功能特性',
        coreFeaturesSubtitle:
            '探索 Google Nano Banana Pro 人工智能图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        soatTitle: '完美文字渲染，设计稿一步到位',
        soatDesc:
            '彻底告别 AI 图像中文字扭曲的时代！无论是制作信息图、菜单、海报还是营销物料，它都能生成多种语言的、排版优美的、可直接使用的设计稿。',
        soatAlt: '图像生成示例',

        characterConsistencyTitle: '多图参考与角色锁定，保持绝对一致性',
        characterConsistencyDesc:
            'Nano Banana Pro 支持同时使用多达 14 张参考图片来指导创作，确保品牌 Logo、色彩、产品外观或角色形象的高度一致性。',
        characterConsistencyAlt: '角色一致性示例',

        naturalLanguageTitle: '谷歌搜索赋能，创造基于事实的图像',
        naturalLanguageDesc:
            'Nano Banana Pro 能够连接谷歌搜索，获取实时信息来生成准确的、有据可查的图像。需要一张今天纽约的天气图？或者一张展示最新股价的图表？它都能精准完成，是制作培训手册、技术指南和新闻配图的利器。',
        naturalLanguageAlt: '基于事实的图像示例',

        multiFusionTitle: '原生 4K 超高分辨率，细节经得起考验',
        multiFusionDesc:
            'Nano Banana Pro 支持原生生成 1K、2K 乃至 4K 的超高分辨率图像，提供令人惊叹的细节层次和清晰度。无论是用于印刷品、数字大屏还是影视后期，都能满足最严苛的画质要求。',
        multiFusionAlt: '超高分辨率图像示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Desc: '在 AI 图像工具中选择 Nano Banana Pro 模型',

        step2Title: '输入内容',
        step2Desc: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Desc: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Nano Banana Pro AI 图像模型的YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Nano Banana Pro AI 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro，技术上称为 Gemini 3.0 Pro Image，是 Google 推出的下一代旗舰级 AI 图像模型。与前代不同，它引入了基于 LLM 的“深度推理”能力，使其在生成图像前能先进行逻辑规划。它支持 4K 原生分辨率输出，并具备“多步生成”能力——模型会自我审查草图、纠正错误并优化细节，从而实现前所未有的逻辑一致性和物理准确性。',

        faq2Question: '为什么使用 Nano Banana Pro (Gemini 3.0 Pro Image)？',
        faq2Answer:
            'Nano Banana Pro 是追求极致细节和逻辑性的创作者的首选。它不仅仅是生成图像，更是“理解”图像。其核心优势在于： <br/>1. 推理引导合成：它能理解复杂的空间关系（如“猫在玻璃杯后的折射”），并准确渲染光影和物理交互。 <br/> 2. 完美的文本渲染：它彻底解决了 AI 拼写困难的问题，可以在图像中精准生成复杂的长文本、商标和排版。<br/> 3. 不仅是编辑，更是重构：在修改图像时，它能理解三维结构，允许你改变物体的角度或光照，而不仅仅是表面贴图。',

        faq3Question:
            '我可以免费使用 Google Nano Banana Pro (Gemini 3.0 Pro Image) 吗？',
        faq3Answer:
            '是的。您可以通过WeryAI免费使用Nano Banana Pro (Gemini 3.0 Pro Image) 进行图像生成。只需注册一个账户，我们的免费试用计划就能让您体验这款AI模型的全部功能，快速生成专业级的AI图像。',

        faq4Question:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) 最适合哪些项目？',
        faq4Answer:
            '由于其强大的逻辑推理和 4K 细节表现，Google Nano Banana Pro 是专业级商业应用的完美选择。它特别适合：<br/> 1.复杂的广告设计：能够精准控制产品上的文字和光影。 <br/> 2.长篇视觉叙事：在不同场景、角度和光照下，保持角色（Character Consistency）和物体特征的绝对一致。 <br/> 3.UI/UX 概念设计：能直接生成包含可读文本和正确布局的应用界面原型。',

        faq5Question: 'Google Nano Banana Pro 图像生成器支持哪些艺术风格？',
        faq5Answer:
            'Nano Banana Pro 打破了风格的界限，尤其擅长超写实摄影（Hyper-realism）和复杂的 3D 渲染。除了支持动漫、油画、水彩等传统风格外，它还新增了“逻辑风格化”能力，能够模仿特定的电影布光（如赛博朋克霓虹灯效、自然光纪录片风格）以及精确的技术绘图风格，确保每一处细节都经得起推敲。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription:
            '立即体验 Google Nano Banana Pro，将您的创意转化为精彩图像',
        ctaButton: '立即体验 Nano Banana Pro',
        ctaDisclaimer: '无需信用卡',
    },
    en: {
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        metaTitle: 'Nano Banana Pro AI画像ジェネレーター ',
        metaDescription:
            'Nano Banana Pro（Gemini 3.0 Pro Image）は、Google が発表した世界初の「推論画像エンジン」です。単に画像を描くだけでなく、物理法則や空間ロジックを理解します。Nano Banana のフラッグシップアップグレード版として、人間のようにシーンを「考え」「計画」し、かつてない論理的一貫性、完璧なテキスト表現、超高解像度を備えたビジュアルを生成します。今すぐ 微鲤AI の画像ジェネレーターで Nano Banana Pro を無料でお試しいただけます。',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, 画像生成, AI絵画, 人工知能, 画像編集, キャラクター一貫性',

        generatorTitle: 'Google Nano Banana Pro AI画像ジェネレーター',
        generatorSubtitle:
            'Nano Banana Pro（Gemini 3.0 Pro Image）は、Google が発表した世界初の「推論画像エンジン」です。物理法則や空間ロジックを理解し、人間のようにシーンを計画してから画像を生成します。Nano Banana のフラッグシップ版として、ネイティブ 4K 出力と高精度なテキストレンダリングを備え、複雑なマルチステップ指示やキャラクター一貫性を必要とするクリエイティブに最適です。',

        coreFeaturesTitle: 'Nano Banana Pro のコア機能',
        coreFeaturesSubtitle:
            'Google Nano Banana Pro AI画像ジェネレーターのコア機能を探索し、革新的なAI画像制作の旅を始めましょう',

        // 機能
        soatTitle: '完璧な文字レンダリングで、そのまま使えるデザイン',
        soatDesc:
            '文字が崩れたり読めなくなる AI 画像とはもうさよなら。インフォグラフィック、メニュー、ポスター、マーケティング資料など、Nano Banana Pro は複数言語に対応した、美しく整ったレイアウトをそのまま使える形で生成します。',
        soatAlt: 'テキストレンダリングの例',

        characterConsistencyTitle:
            '多枚数リファレンスとキャラクターロックで完全な一貫性',
        characterConsistencyDesc:
            'Nano Banana Pro は最大 14 枚までのリファレンス画像を同時に指定でき、ブランドロゴやカラー、プロダクト外観、キャラクターのビジュアルを常に高い一貫性で保ちます。',
        characterConsistencyAlt: 'キャラクター一貫性の例',

        naturalLanguageTitle: 'Google 検索連携で、事実に基づいた画像生成',
        naturalLanguageDesc:
            'Nano Banana Pro は Google 検索と連携し、最新情報に基づいた正確な画像を生成できます。たとえば「今日のニューヨークの天気図」や「最新株価を示すチャート」など、トレーニング資料、技術ドキュメント、ニュース用イラストに最適です。',
        naturalLanguageAlt: '事実に基づいた画像の例',

        multiFusionTitle: 'ネイティブ 4K 超高解像度、細部まで妥協なし',
        multiFusionDesc:
            'Nano Banana Pro は 1K・2K・4K の超高解像度をネイティブで生成し、驚くほど精細なディテールとクリアさを実現します。印刷物、大型デジタルサイネージ、映像ポストプロダクションなど、もっとも厳しい画質要件にも対応できます。',
        multiFusionAlt: '超高解像度画像の例',

        howToUseTitle: '使い方',
        howToUseSubtitle: '3ステップでかんたんにクリエイティブを開始',

        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールで Nano Banana Pro モデルを選択',
        step1Desc: 'AI画像ツールで Nano Banana Pro モデルを選択',

        step2Title: 'コンテンツを入力',
        step2Description:
            'プロンプトを入力するか、参照用の画像をアップロードします',
        step2Desc: 'プロンプトを入力するか、参照用の画像をアップロードします',

        step3Title: '画像を生成',
        step3Description:
            '生成ボタンをクリックし、少し待ってから画像をダウンロードします',
        step3Desc:
            '生成ボタンをクリックし、少し待ってから画像をダウンロードします',

        youtubeTitle: 'Nano Banana Pro AI 画像モデルに関する YouTube 動画',

        xPostsTitle: 'Nano Banana Pro AI 画像モデルに関する X 投稿',

        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Wan AI画像ジェネレーター',
        model2Title: 'FLUX AI画像ジェネレーター',
        model3Title: 'Google Imagen AI画像ジェネレーター',

        exploreTitle: '微鲤AI で他の AI 画像モデルを探索する',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image 画像ジェネレーター',
        seedreamTitle: 'Seedream 画像ジェネレーター',

        faqTitle: 'よくある質問',

        faq1Question: 'Google Nano Banana Proとは何ですか？',
        faq1Answer:
            'Nano Banana Proは、技術的にはGemini 3.0 Pro Imageと呼ばれ、Googleが開発した次世代フラグシップAI画像モデルです。前世代とは異なり、LLMベースの「深度推論」能力を導入し、画像生成前に論理的な計画を実行できるようになりました。ネイティブ4K解像度出力をサポートし、「マルチステップ生成」機能を備えています—モデルはスケッチを自己レビューし、エラーを修正し、詳細を最適化し、これまでにない論理的一貫性と物理的精度を実現します。',

        faq2Question:
            'なぜNano Banana Pro (Gemini 3.0 Pro Image)を使用するのですか？',
        faq2Answer:
            'Nano Banana Proは、極限の細部と論理性を追求するクリエイターの最良の選択です。単に画像を生成するだけでなく、画像を「理解」します。その核心的な利点は：<br/>1. 推論誘導合成：複雑な空間関係（「ガラスの後ろの猫の屈折」など）を理解し、光と影、物理的相互作用を正確にレンダリングします。<br/>2. 完璧なテキストレンダリング：AIのスペル困難の問題を完全に解決し、画像内で複雑な長文、商標、タイポグラフィを正確に生成できます。<br/>3. 編集だけでなく、再構築：画像を変更する際、三次元構造を理解し、表面テクスチャだけでなく、オブジェクトの角度や照明を変更できます。',

        faq3Question:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image)を無料で使用できますか？',
        faq3Answer:
            'はい。WeryAIを通じてNano Banana Pro (Gemini 3.0 Pro Image)を無料で画像生成に使用できます。アカウントを登録するだけで、無料トライアルプランでこのAIモデルの全機能を体験し、プロフェッショナルレベルのAI画像を迅速に生成できます。',

        faq4Question:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image)はどのようなプロジェクトに最適ですか？',
        faq4Answer:
            '強力な論理推論と4K詳細表現により、Google Nano Banana Proはプロフェッショナルレベルの商業アプリケーションに最適です。特に以下に適しています：<br/>1. 複雑な広告デザイン：製品上のテキストと照明を正確に制御できます。<br/>2. 長編視覚的ストーリーテリング：異なるシーン、角度、照明の下で、キャラクター（Character Consistency）とオブジェクトの特徴の絶対的な一貫性を維持します。<br/>3. UI/UXコンセプトデザイン：読み取り可能なテキストと正しいレイアウトを含むアプリケーションインターフェースプロトタイプを直接生成できます。',

        faq5Question:
            'Google Nano Banana Pro画像ジェネレーターはどのような芸術スタイルをサポートしていますか？',
        faq5Answer:
            'Nano Banana Proはスタイルの境界を打ち破り、特に超写実写真（Hyper-realism）と複雑な3Dレンダリングに優れています。アニメ、油絵、水彩などの伝統的なスタイルをサポートするだけでなく、「論理的スタイライゼーション」機能も追加され、特定の映画照明（サイバーパンクネオン効果、自然光ドキュメンタリースタイルなど）や正確な技術図面スタイルを模倣でき、すべての詳細が精査に耐えることを保証します。',

        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription:
            '今すぐGoogle Nano Bananaを体験し、あなたのアイデアを素晴らしい画像に変換',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ko: {
        metaTitle: 'Nano Banana Pro AI 이미지 생성기 ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image)는 Google이 출시한 세계 최초의 "추론 이미지 엔진"입니다. 단순히 이미지를 그리는 것을 넘어, 물리 법칙과 공간 논리를 이해합니다. Nano Banana의 플래그십 업그레이드 버전으로서, 사람처럼 장면을 "생각"하고 "계획"한 뒤 이미지를 생성하며, 전례 없는 논리적 일관성, 완벽한 텍스트 표현, 초고해상도 품질을 제공합니다. 지금 微鲤AI 이미지 생성기에서 Nano Banana Pro를 무료로 체험할 수 있습니다.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, 이미지 생성, AI 그림, 인공지능, 이미지 편집, 캐릭터 일관성',

        generatorTitle: 'Google Nano Banana Pro AI 이미지 생성기',
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image)는 세계 최초의 "추론 이미지 엔진"으로, 물리 법칙과 공간 논리를 이해하며 사람처럼 장면을 계획한 뒤 이미지를 생성합니다. Nano Banana의 플래그십 버전으로서 네이티브 4K 해상도 출력과 고정밀 텍스트 렌더링을 지원하여, 복잡한 멀티스텝 지시와 캐릭터 일관성이 필요한 프로젝트에 최적화되어 있습니다.',

        coreFeaturesTitle: 'Nano Banana Pro의 핵심 기능',
        coreFeaturesSubtitle:
            'Google Nano Banana Pro AI 이미지 생성기의 핵심 기능을 살펴보고, 혁신적인 AI 이미지 제작 여정을 시작하세요',

        // 기능
        soatTitle: '완벽한 텍스트 렌더링, 바로 사용 가능한 디자인',
        soatDesc:
            '텍스트가 깨지거나 읽기 어려운 AI 이미지 시대는 끝났습니다. 인포그래픽, 메뉴, 포스터, 마케팅 자료 등 어떤 용도든 Nano Banana Pro는 여러 언어를 지원하는, 아름답게 레이아웃된 디자인 시안을 한 번에 생성합니다.',
        soatAlt: '텍스트 렌더링 예시',

        characterConsistencyTitle:
            '다중 이미지 레퍼런스와 캐릭터 락으로 완벽한 일관성',
        characterConsistencyDesc: '여러 이미지에서 일관된 캐릭터 외관 유지',
        characterConsistencyAlt: '캐릭터 일관성 예시',

        naturalLanguageTitle: 'Google 검색 기반의 사실 정보 이미지 생성',
        naturalLanguageDesc:
            'Nano Banana Pro는 Google 검색과 연동하여, 최신 정보에 기반한 정확하고 검증 가능한 이미지를 생성합니다. 오늘 뉴욕의 날씨를 보여주는 이미지나, 최신 주가 차트가 필요하신가요? 교육 매뉴얼, 기술 문서, 뉴스 일러스트 제작에 최적입니다.',
        naturalLanguageAlt: '사실 기반 이미지 예시',

        multiFusionTitle: '네이티브 4K 초고해상도, 디테일까지 완벽하게',
        multiFusionDesc:
            'Nano Banana Pro는 1K, 2K, 4K 초고해상도 이미지를 네이티브로 생성하여, 놀라운 디테일과 선명도를 제공합니다. 인쇄물, 대형 디지털 스크린, 영상 후반 작업 등 가장 까다로운 화질 요구 사항도 충족합니다.',
        multiFusionAlt: '초고해상도 이미지 예시',

        howToUseTitle: '사용 방법',
        howToUseSubtitle: '3단계로 간단하게 시작',

        step1Title: '모델 선택',
        step1Description:
            'AI 이미지 도구에서 Nano Banana Pro 모델을 선택합니다',
        step1Desc: 'AI 이미지 도구에서 Nano Banana Pro 모델을 선택합니다',

        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트를 입력하거나 참고용 이미지를 업로드합니다',
        step2Desc: '프롬프트를 입력하거나 참고용 이미지를 업로드합니다',

        step3Title: '이미지 생성',
        step3Description:
            '생성 버튼을 클릭한 뒤 잠시 기다렸다가 이미지를 다운로드합니다',
        step3Desc:
            '생성 버튼을 클릭한 뒤 잠시 기다렸다가 이미지를 다운로드합니다',

        youtubeTitle: 'Nano Banana Pro AI 이미지 모델에 대한 YouTube 동영상',

        xPostsTitle: 'Nano Banana Pro AI 이미지 모델에 대한 X 게시물',

        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Wan AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Google Imagen AI 이미지 생성기',

        exploreTitle: 'WeryAI에서 다른 AI 이미지 모델 둘러보기',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image 이미지 생성기',
        seedreamTitle: 'Seedream 이미지 생성기',

        faqTitle: '자주 묻는 질문',

        faq1Question: 'Google Nano Banana Pro가 무엇인가요?',
        faq1Answer:
            'Nano Banana Pro는 기술적으로 Gemini 3.0 Pro Image라고 불리며, Google이 개발한 차세대 플래그십 AI 이미지 모델입니다. 전 세대와 달리 LLM 기반 "심층 추론" 능력을 도입하여 이미지 생성 전에 논리적 계획을 수행할 수 있습니다. 네이티브 4K 해상도 출력을 지원하며 "다단계 생성" 기능을 갖추고 있습니다—모델은 스케치를 자체 검토하고, 오류를 수정하며, 세부 사항을 최적화하여 전례 없는 논리적 일관성과 물리적 정확성을 달성합니다.',

        faq2Question: '왜 Nano Banana Pro (Gemini 3.0 Pro Image)를 사용하나요?',
        faq2Answer:
            'Nano Banana Pro는 극한의 세부 사항과 논리를 추구하는 크리에이터의 최고 선택입니다. 단순히 이미지를 생성하는 것이 아니라 이미지를 "이해"합니다. 핵심 장점은 다음과 같습니다: <br/>1. 추론 유도 합성: 복잡한 공간 관계(예: "유리 뒤의 고양이 굴절")를 이해하고 빛, 그림자, 물리적 상호작용을 정확하게 렌더링합니다. <br/>2. 완벽한 텍스트 렌더링: AI 맞춤법 어려움 문제를 완전히 해결하여 이미지에서 복잡한 긴 텍스트, 상표 및 타이포그래피를 정확하게 생성할 수 있습니다. <br/>3. 편집뿐만 아니라 재구성: 이미지를 수정할 때 3차원 구조를 이해하여 표면 텍스처뿐만 아니라 객체의 각도나 조명을 변경할 수 있습니다.',

        faq3Question:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image)를 무료로 사용할 수 있나요?',
        faq3Answer:
            '네. WeryAI를 통해 Nano Banana Pro (Gemini 3.0 Pro Image)를 무료로 이미지 생성에 사용할 수 있습니다. 계정을 등록하기만 하면 무료 체험 플랜을 통해 이 AI 모델의 모든 기능을 경험하고 전문가 수준의 AI 이미지를 빠르게 생성할 수 있습니다.',

        faq4Question:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image)는 어떤 프로젝트에 가장 적합한가요?',
        faq4Answer:
            '강력한 논리 추론과 4K 세부 사항 성능으로 인해 Google Nano Banana Pro는 전문가 수준의 상업용 애플리케이션에 완벽한 선택입니다. 특히 다음에 적합합니다: <br/>1. 복잡한 광고 디자인: 제품의 텍스트와 조명을 정확하게 제어할 수 있습니다. <br/>2. 장편 시각적 스토리텔링: 다양한 장면, 각도 및 조명에서 캐릭터(Character Consistency) 및 객체 특징의 절대적 일관성을 유지합니다. <br/>3. UI/UX 개념 디자인: 읽을 수 있는 텍스트와 올바른 레이아웃을 포함한 애플리케이션 인터페이스 프로토타입을 직접 생성할 수 있습니다.',

        faq5Question:
            'Google Nano Banana Pro 이미지 생성기는 어떤 예술 스타일을 지원하나요?',
        faq5Answer:
            'Nano Banana Pro는 스타일의 경계를 깨고 특히 초현실적 사진(Hyper-realism)과 복잡한 3D 렌더링에 뛰어납니다. 애니메, 유화, 수채화와 같은 전통적인 스타일을 지원할 뿐만 아니라 "논리적 스타일화" 기능도 추가되어 특정 영화 조명(사이버펑크 네온 효과, 자연광 다큐멘터리 스타일 등)과 정확한 기술 도면 스타일을 모방할 수 있어 모든 세부 사항이 검토에 견딜 수 있도록 보장합니다.',

        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 Google Nano Banana를 체험하고 당신의 아이디어를 놀라운 이미지로 변환하세요',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    tw: {

        // SEO Meta
        metaTitle: 'Nano Banana Pro 人工智能图像生成器 ',
        metaDescription:
            'Nano Banana Pro（Gemini 3.0 Pro Image）是 Google 推出的全球首个“推理图像引擎”，不仅能绘画，更能理解物理规律与空间逻辑。作为 Nano Banana 的旗舰升级版，它能像人类一样“思考”和“规划”场景，生成前所未有的逻辑一致性、完美文字和超高分辨率的视觉作品。现在就可以在 微鲤AI 图像生成器中免费试用 Nano Banana Pro。',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, 图像生成, AI 绘画, 人工智能, 图像编辑, 角色一致性',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro 人工智能图像生成器',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, 图像生成, AI 绘画, 人工智能, 图像编辑, 角色一致性',

        // Core Features Section
        coreFeaturesTitle: 'Nano Banana Pro 核心功能特性',
        coreFeaturesSubtitle:
            '探索 Google Nano Banana Pro 人工智能图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        soatTitle: '完美文字渲染，设计稿一步到位',
        soatDesc:
            '彻底告别 AI 图像中文字扭曲的时代！无论是制作信息图、菜单、海报还是营销物料，它都能生成多种语言的、排版优美的、可直接使用的设计稿。',
        soatAlt: '图像生成示例',

        characterConsistencyTitle: '多图参考与角色锁定，保持绝对一致性',
        characterConsistencyDesc:
            'Nano Banana Pro 支持同时使用多达 14 张参考图片来指导创作，确保品牌 Logo、色彩、产品外观或角色形象的高度一致性。',
        characterConsistencyAlt: '角色一致性示例',

        naturalLanguageTitle: '谷歌搜索赋能，创造基于事实的图像',
        naturalLanguageDesc:
            'Nano Banana Pro 能够连接谷歌搜索，获取实时信息来生成准确的、有据可查的图像。需要一张今天纽约的天气图？或者一张展示最新股价的图表？它都能精准完成，是制作培训手册、技术指南和新闻配图的利器。',
        naturalLanguageAlt: '基于事实的图像示例',

        multiFusionTitle: '原生 4K 超高分辨率，细节经得起考验',
        multiFusionDesc:
            'Nano Banana Pro 支持原生生成 1K、2K 乃至 4K 的超高分辨率图像，提供令人惊叹的细节层次和清晰度。无论是用于印刷品、数字大屏还是影视后期，都能满足最严苛的画质要求。',
        multiFusionAlt: '超高分辨率图像示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Desc: '在 AI 图像工具中选择 Nano Banana Pro 模型',

        step2Title: '输入内容',
        step2Desc: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Desc: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Nano Banana Pro AI 图像模型的YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Nano Banana Pro AI 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro，技术上称为 Gemini 3.0 Pro Image，是 Google 推出的下一代旗舰级 AI 图像模型。与前代不同，它引入了基于 LLM 的“深度推理”能力，使其在生成图像前能先进行逻辑规划。它支持 4K 原生分辨率输出，并具备“多步生成”能力——模型会自我审查草图、纠正错误并优化细节，从而实现前所未有的逻辑一致性和物理准确性。',

        faq2Question: '为什么使用 Nano Banana Pro (Gemini 3.0 Pro Image)？',
        faq2Answer:
            'Nano Banana Pro 是追求极致细节和逻辑性的创作者的首选。它不仅仅是生成图像，更是“理解”图像。其核心优势在于： <br/>1. 推理引导合成：它能理解复杂的空间关系（如“猫在玻璃杯后的折射”），并准确渲染光影和物理交互。 <br/> 2. 完美的文本渲染：它彻底解决了 AI 拼写困难的问题，可以在图像中精准生成复杂的长文本、商标和排版。<br/> 3. 不仅是编辑，更是重构：在修改图像时，它能理解三维结构，允许你改变物体的角度或光照，而不仅仅是表面贴图。',

        faq3Question:
            '我可以免费使用 Google Nano Banana Pro (Gemini 3.0 Pro Image) 吗？',
        faq3Answer:
            '是的。您可以通过WeryAI免费使用Nano Banana Pro (Gemini 3.0 Pro Image) 进行图像生成。只需注册一个账户，我们的免费试用计划就能让您体验这款AI模型的全部功能，快速生成专业级的AI图像。',

        faq4Question:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) 最适合哪些项目？',
        faq4Answer:
            '由于其强大的逻辑推理和 4K 细节表现，Google Nano Banana Pro 是专业级商业应用的完美选择。它特别适合：<br/> 1.复杂的广告设计：能够精准控制产品上的文字和光影。 <br/> 2.长篇视觉叙事：在不同场景、角度和光照下，保持角色（Character Consistency）和物体特征的绝对一致。 <br/> 3.UI/UX 概念设计：能直接生成包含可读文本和正确布局的应用界面原型。',

        faq5Question: 'Google Nano Banana Pro 图像生成器支持哪些艺术风格？',
        faq5Answer:
            'Nano Banana Pro 打破了风格的界限，尤其擅长超写实摄影（Hyper-realism）和复杂的 3D 渲染。除了支持动漫、油画、水彩等传统风格外，它还新增了“逻辑风格化”能力，能够模仿特定的电影布光（如赛博朋克霓虹灯效、自然光纪录片风格）以及精确的技术绘图风格，确保每一处细节都经得起推敲。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription:
            '立即体验 Google Nano Banana Pro，将您的创意转化为精彩图像',
        ctaButton: '立即体验 Nano Banana Pro',
        ctaDisclaimer: '无需信用卡',
    },
    pl: {

        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        metaTitle: 'Generador de Imágenes IA Nano Banana Pro ',
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) es un modelo revolucionario de generación de imágenes IA lanzado por Google el 20 de noviembre. Introduce capacidades de "razonamiento profundo" sin precedentes, permitiéndole no solo pintar, sino también comprender las leyes físicas y la lógica espacial, logrando "planificar primero, luego generar". Como actualización insignia de Nano Banana Pro, admite salida de resolución 4K nativa y capacidades perfectas de renderizado de texto, puede manejar instrucciones de múltiples pasos extremadamente complejas y garantizar la consistencia absoluta de personajes en diferentes escenarios, lo que lo convierte en la herramienta definitiva para diseño publicitario, narrativa visual y creadores profesionales que buscan detalles extremos.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, generación de imágenes, pintura IA, inteligencia artificial, edición de imágenes, consistencia de personajes',
        generatorTitle: 'Generador de Imágenes IA Google Nano Banana Pro',
        generatorSubtitle:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) es un modelo revolucionario de generación de imágenes IA lanzado por Google el 20 de noviembre. Introduce capacidades de "razonamiento profundo" sin precedentes, permitiéndole no solo pintar, sino también comprender las leyes físicas y la lógica espacial, logrando "planificar primero, luego generar". Como actualización insignia de Nano Banana Pro, admite salida de resolución 4K nativa y capacidades perfectas de renderizado de texto, puede manejar instrucciones de múltiples pasos extremadamente complejas y garantizar la consistencia absoluta de personajes en diferentes escenarios, lo que lo convierte en la herramienta definitiva para diseño publicitario, narrativa visual y creadores profesionales que buscan detalles extremos.',

        // Sección de características principales
        coreFeaturesTitle: 'Funciones clave de Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explora las funciones principales del generador de imágenes IA Google Nano Banana Pro y comienza un viaje revolucionario de creación de imágenes con IA',

        // Funciones
        soatTitle: 'Renderizado de texto perfecto, diseños listos para usar',
        soatDesc:
            'Di adiós para siempre al texto torcido o ilegible en imágenes generadas por IA. Ya sea para infografías, menús, carteles o material de marketing, Nano Banana Pro genera composiciones tipográficas en varios idiomas listas para usar directamente.',
        soatAlt: 'Ejemplo de renderizado de texto',

        characterConsistencyTitle:
            'Referencia múltiple y bloqueo de personaje para una consistencia absoluta',
        characterConsistencyDesc:
            'Nano Banana Pro admite hasta 14 imágenes de referencia simultáneas para guiar la creación, garantizando una alta consistencia de logotipos de marca, colores, aspecto del producto e identidad del personaje en todas tus creatividades.',
        characterConsistencyAlt: 'Ejemplo de consistencia de personaje',

        naturalLanguageTitle:
            'Impulsado por Google Search para imágenes basadas en hechos',
        naturalLanguageDesc:
            'Nano Banana Pro puede conectarse con Google Search para obtener información en tiempo real y generar imágenes exactas y verificables. ¿Necesitas una imagen del tiempo de hoy en Nueva York o un gráfico con los precios bursátiles más recientes? Lo resuelve con precisión, ideal para manuales de formación, guías técnicas e ilustraciones de noticias.',
        naturalLanguageAlt: 'Ejemplo de imagen basada en hechos',

        multiFusionTitle:
            'Resolución 4K nativa, detalles que resisten cualquier examen',
        multiFusionDesc:
            'Nano Banana Pro puede generar de forma nativa imágenes en 1K, 2K e incluso 4K con un nivel de detalle y nitidez impresionantes. Ya sea para impresión, pantallas digitales de gran formato o postproducción de cine, cumple los requisitos de calidad de imagen más exigentes.',
        multiFusionAlt: 'Ejemplo de imagen en ultra alta resolución',

        // Sección Cómo usar
        howToUseTitle: 'Cómo usarlo',
        howToUseSubtitle: 'Empieza a crear en tres sencillos pasos',

        step1Title: 'Elige el modelo',
        step1Desc:
            'En las herramientas de imagen con IA, selecciona el modelo Nano Banana Pro',

        step2Title: 'Introduce el contenido',
        step2Desc: 'Escribe tus prompts o sube imágenes de referencia',

        step3Title: 'Genera la imagen',
        step3Desc:
            'Haz clic en el botón de generar, espera y descarga tu imagen',

        // Sección de vídeos de YouTube
        youtubeTitle:
            'Vídeos de YouTube sobre el modelo de imagen IA Nano Banana Pro',

        // Sección de publicaciones en X
        xPostsTitle:
            'Publicaciones en X sobre el modelo de imagen IA Nano Banana Pro',

        // Explorar otros modelos
        exploreTitle: 'Explora otros modelos de imagen IA en 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Generador de Imágenes Qwen',
        seedreamTitle: 'Generador de Imágenes Seedream',

        faqTitle: 'Preguntas Frecuentes',

        faq1Question: '¿Qué es Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, técnicamente conocido como Gemini 3.0 Pro Image, es el modelo de imágenes IA insignia de próxima generación de Google. A diferencia de su predecesor, introduce capacidades de "razonamiento profundo" basadas en LLM, permitiéndole realizar planificación lógica antes de generar imágenes. Admite salida de resolución 4K nativa y cuenta con capacidades de "generación multi-paso": el modelo auto-revisa bocetos, corrige errores y optimiza detalles, logrando una consistencia lógica y precisión física sin precedentes.',

        faq2Question: '¿Por qué usar Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro es la mejor opción para creadores que buscan detalles extremos y lógica. No solo genera imágenes, sino que las "entiende". Sus ventajas principales incluyen: <br/>1. Síntesis guiada por razonamiento: Entiende relaciones espaciales complejas (como "refracción de un gato detrás de un vaso") y renderiza con precisión luz, sombra e interacciones físicas. <br/>2. Renderizado de texto perfecto: Resuelve completamente el problema de dificultad de ortografía de IA, permitiendo la generación precisa de texto largo complejo, marcas comerciales y tipografía en imágenes. <br/>3. No solo edición, sino reconstrucción: Al modificar imágenes, entiende la estructura tridimensional, permitiéndote cambiar ángulos u iluminación de objetos, no solo texturas superficiales.',

        faq3Question:
            '¿Puedo usar Google Nano Banana Pro (Gemini 3.0 Pro Image) gratis?',
        faq3Answer:
            'Sí. Puedes usar Nano Banana Pro (Gemini 3.0 Pro Image) para generación de imágenes gratis a través de 微鲤AI. Simplemente registra una cuenta, y nuestro plan de prueba gratuito te permite experimentar todas las capacidades de este modelo IA para generar rápidamente imágenes IA de nivel profesional.',

        faq4Question:
            '¿Para qué proyectos es más adecuado Google Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq4Answer:
            'Debido a su poderoso razonamiento lógico y rendimiento de detalles 4K, Google Nano Banana Pro es la opción perfecta para aplicaciones comerciales profesionales. Es particularmente adecuado para: <br/>1. Diseño publicitario complejo: Puede controlar con precisión texto e iluminación en productos. <br/>2. Narrativa visual de larga duración: Mantiene consistencia absoluta de personajes (Character Consistency) y características de objetos en diferentes escenas, ángulos e iluminación. <br/>3. Diseño de concepto UI/UX: Puede generar directamente prototipos de interfaz de aplicación que contengan texto legible y diseños correctos.',

        faq5Question:
            '¿Qué estilos artísticos admite el generador de imágenes Google Nano Banana Pro?',
        faq5Answer:
            'Nano Banana Pro rompe los límites del estilo, destacando particularmente en fotografía hiperrealista (Hyper-realism) y renderizado 3D complejo. Además de admitir estilos tradicionales como anime, pintura al óleo y acuarela, también agrega capacidades de "estilización lógica", capaz de imitar iluminación cinematográfica específica (como efectos de neón cyberpunk, estilo documental de luz natural) y estilos de dibujo técnico precisos, asegurando que cada detalle resista el escrutinio.',

        // Sección CTA
        ctaTitle: '¿Listo para empezar a crear?',
        ctaDescription:
            'Prueba ahora Google Nano Banana Pro y transforma tus ideas en imágenes increíbles',
        ctaButton: 'Probar Nano Banana Pro en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        metaTitle: "Générateur d'Images IA Nano Banana Pro ",
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) est un modèle révolutionnaire de génération d\'images IA lancé par Google le 20 novembre. Il introduit des capacités de "raisonnement profond" sans précédent, lui permettant non seulement de peindre, mais aussi de comprendre les lois physiques et la logique spatiale, réalisant ainsi "planifier d\'abord, puis générer". En tant que mise à niveau phare de Nano Banana Pro, il prend en charge la sortie de résolution 4K native et des capacités de rendu de texte parfaites, peut gérer des instructions multi-étapes extrêmement complexes et assurer la cohérence absolue des personnages dans différents scénarios, ce qui en fait l\'outil ultime pour la conception publicitaire, la narration visuelle et les créateurs professionnels recherchant des détails extrêmes.',
        metaKeywords:
            "Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, génération d'images, peinture IA, intelligence artificielle, édition d'images, cohérence des personnages",
        generatorTitle: "Générateur d'Images IA Google Nano Banana Pro",
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image) est le premier "moteur d’images par raisonnement" au monde lancé par Google. Il ne se contente pas de générer des images, il comprend aussi les lois physiques et la logique spatiale. En tant que mise à niveau phare de Nano Banana, il peut "penser" et "planifier" les scènes comme un humain, produisant des visuels d’une cohérence logique inédite, avec un rendu de texte parfait et une ultra-haute résolution. Vous pouvez dès maintenant essayer gratuitement Nano Banana Pro dans le générateur d’images 微鲤AI.',

        // Section fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités clés de Nano Banana Pro',
        coreFeaturesSubtitle:
            "Découvrez les fonctionnalités clés du générateur d'images IA Google Nano Banana Pro et commencez un voyage révolutionnaire de création visuelle avec l’IA",

        // Fonctionnalités
        soatTitle: 'Rendu de texte parfait, maquettes prêtes à l’emploi',
        soatDesc:
            'Dites adieu au texte déformé ou illisible dans les images générées par IA. Pour les infographies, menus, affiches ou supports marketing, Nano Banana Pro génère des compositions typographiques multilingues prêtes à être utilisées directement.',
        soatAlt: 'Exemple de rendu de texte',

        characterConsistencyTitle:
            'Références multiples et verrouillage de personnage pour une cohérence absolue',
        characterConsistencyDesc:
            'Nano Banana Pro prend en charge jusqu’à 14 images de référence simultanées pour guider la création, garantissant une grande cohérence des logos de marque, des couleurs, de l’apparence des produits et de l’identité des personnages dans tous vos visuels.',
        characterConsistencyAlt: 'Exemple de cohérence de personnage',

        naturalLanguageTitle:
            'Propulsé par Google Search pour des images basées sur des faits',
        naturalLanguageDesc:
            'Nano Banana Pro peut se connecter à Google Search pour récupérer des informations en temps réel et générer des images exactes et vérifiables. Besoin d’une image de la météo du jour à New York ou d’un graphique montrant les derniers cours boursiers ? Il s’en charge avec précision, idéal pour les manuels de formation, guides techniques et illustrations d’actualité.',
        naturalLanguageAlt: 'Exemple d’image basée sur des faits',

        multiFusionTitle: 'Résolution 4K native, des détails irréprochables',
        multiFusionDesc:
            'Nano Banana Pro peut générer nativement des images en 1K, 2K et même 4K avec un niveau de détail et de netteté impressionnant. Que ce soit pour l’impression, les écrans numériques grand format ou la post-production vidéo, il répond aux exigences de qualité d’image les plus strictes.',
        multiFusionAlt: 'Exemple d’image en ultra haute résolution',

        // Section Comment l’utiliser
        howToUseTitle: 'Comment l’utiliser',
        howToUseSubtitle: 'Commencez à créer en trois étapes simples',

        step1Title: 'Choisir le modèle',
        step1Desc:
            "Dans les outils d'images IA, sélectionnez le modèle Nano Banana Pro",

        step2Title: 'Saisir le contenu',
        step2Desc: 'Saisissez vos prompts ou importez des images de référence',

        step3Title: 'Générer l’image',
        step3Desc:
            'Cliquez sur le bouton Générer, patientez quelques instants, puis téléchargez votre image',

        // Section vidéos YouTube
        youtubeTitle:
            'Vidéos YouTube sur le modèle d’images IA Nano Banana Pro',

        // Section posts X
        xPostsTitle: 'Publications X sur le modèle d’images IA Nano Banana Pro',

        // Explorer d’autres modèles
        exploreTitle: 'Explorer d’autres modèles d’images IA sur 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Générateur d’Images Qwen',
        seedreamTitle: 'Générateur d’Images Seedream',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',

        faq1Question: "Qu'est-ce que Google Nano Banana Pro?",
        faq1Answer:
            'Nano Banana Pro, techniquement connu sous le nom de Gemini 3.0 Pro Image, est le modèle d\'images IA phare de nouvelle génération de Google. Contrairement à son prédécesseur, il introduit des capacités de "raisonnement profond" basées sur LLM, lui permettant d\'effectuer une planification logique avant de générer des images. Il prend en charge la sortie de résolution 4K native et dispose de capacités de "génération multi-étapes": le modèle auto-examine les croquis, corrige les erreurs et optimise les détails, atteignant une cohérence logique et une précision physique sans précédent.',

        faq2Question:
            'Pourquoi utiliser Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            "Nano Banana Pro est le choix optimal pour les créateurs recherchant des détails extrêmes et de la logique. Il ne génère pas seulement des images—il les \"comprend\". Ses avantages principaux incluent: <br/>1. Synthèse guidée par le raisonnement: Il comprend les relations spatiales complexes (comme \"réfraction d'un chat derrière un verre\") et rend avec précision la lumière, l'ombre et les interactions physiques. <br/>2. Rendu de texte parfait: Il résout complètement le problème de difficulté d'orthographe de l'IA, permettant la génération précise de texte long complexe, de marques commerciales et de typographie dans les images. <br/>3. Pas seulement l'édition, mais la reconstruction: Lors de la modification d'images, il comprend la structure tridimensionnelle, vous permettant de changer les angles ou l'éclairage des objets, pas seulement les textures de surface.",

        faq3Question:
            'Puis-je utiliser Google Nano Banana Pro (Gemini 3.0 Pro Image) gratuitement?',
        faq3Answer:
            "Oui. Vous pouvez utiliser Nano Banana Pro (Gemini 3.0 Pro Image) pour la génération d'images gratuite via 微鲤AI. Il suffit de créer un compte, et notre plan d'essai gratuit vous permet d'expérimenter toutes les capacités de ce modèle IA pour générer rapidement des images IA de niveau professionnel.",

        faq4Question:
            'Pour quels projets Google Nano Banana Pro (Gemini 3.0 Pro Image) est-il le mieux adapté?',
        faq4Answer:
            "En raison de son puissant raisonnement logique et de ses performances de détails 4K, Google Nano Banana Pro est le choix parfait pour les applications commerciales professionnelles. Il est particulièrement adapté pour: <br/>1. Conception publicitaire complexe: Peut contrôler avec précision le texte et l'éclairage sur les produits. <br/>2. Narration visuelle longue: Maintient la cohérence absolue des personnages (Character Consistency) et des caractéristiques d'objets dans différentes scènes, angles et éclairages. <br/>3. Conception de concept UI/UX: Peut générer directement des prototypes d'interface d'application contenant du texte lisible et des mises en page correctes.",

        faq5Question:
            "Quels styles artistiques le générateur d'images Google Nano Banana Pro prend-il en charge?",
        faq5Answer:
            "Nano Banana Pro brise les limites du style, excellant particulièrement en photographie hyperréaliste (Hyper-realism) et en rendu 3D complexe. En plus de prendre en charge les styles traditionnels tels que l'anime, la peinture à l'huile et l'aquarelle, il ajoute également des capacités de \"stylisation logique\", capable d'imiter l'éclairage cinématographique spécifique (comme les effets de néon cyberpunk, style documentaire à lumière naturelle) et les styles de dessin technique précis, garantissant que chaque détail résiste à l'examen.",

        // Section CTA
        ctaTitle: 'Prêt à commencer à créer ?',
        ctaDescription:
            'Essayez dès maintenant Google Nano Banana Pro et transformez vos idées en images remarquables',
        ctaButton: 'Essayer Nano Banana Pro sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte bancaire requise',
    },
    de: {
        metaTitle: 'Nano Banana Pro KI-Bildgenerator ',
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) ist ein revolutionäres KI-Bildgenerierungsmodell, das Google am 20. November vorgestellt hat. Es führt beispiellose "Tiefenargumentations"-Fähigkeiten ein, die es nicht nur zum Malen, sondern auch zum Verstehen physikalischer Gesetze und räumlicher Logik befähigen und so "zuerst planen, dann generieren" ermöglichen. Als Flaggschiff-Upgrade von Nano Banana Pro unterstützt es native 4K-Auflösungsausgabe und perfekte Textrendering-Fähigkeiten, kann extrem komplexe mehrstufige Anweisungen verarbeiten und absolute Charakterkonsistenz in verschiedenen Szenarien gewährleisten, was es zum ultimativen Werkzeug für Werbedesign, visuelles Storytelling und professionelle Creator macht, die extreme Details anstreben.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, Bildgenerierung, KI-Malerei, künstliche Intelligenz, Bildbearbeitung, Charakterkonsistenz',
        generatorTitle: 'Google Nano Banana Pro KI-Bildgenerator',
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image) ist die weltweit erste von Google eingeführte „Schlussfolgerungs-Bild-Engine“. Sie generiert nicht nur Bilder, sondern versteht auch physikalische Gesetze und räumliche Logik. Als Flaggschiff-Upgrade von Nano Banana kann sie Szenen wie ein Mensch „durchdenken“ und „planen“ und dabei Bilder mit bisher unerreichter logischer Konsistenz, perfektem Textrendering und ultrahoher Auflösung erzeugen. Jetzt können Sie Nano Banana Pro kostenlos im 微鲤AI-Bildgenerator testen.',

        // Kernfunktionen
        coreFeaturesTitle: 'Kernfunktionen von Nano Banana Pro',
        coreFeaturesSubtitle:
            'Entdecken Sie die Kernfunktionen des Google Nano Banana Pro KI-Bildgenerators und starten Sie eine revolutionäre Reise der Bildgenerierung mit KI',

        // Funktionen
        soatTitle: 'Perfektes Textrendering, einsatzbereite Design-Layouts',
        soatDesc:
            'Verabschieden Sie sich von verzerrtem oder unleserlichem Text in KI-Bildern. Ob Infografiken, Speisekarten, Poster oder Marketingmaterialien – Nano Banana Pro erzeugt mehrsprachige, sauber gesetzte Layouts, die direkt verwendet werden können.',
        soatAlt: 'Beispiel für Textrendering',

        characterConsistencyTitle:
            'Mehrbild-Referenzen und Character Lock für absolute Konsistenz',
        characterConsistencyDesc:
            'Nano Banana Pro unterstützt bis zu 14 Referenzbilder gleichzeitig, um die Erstellung zu steuern und eine hohe Konsistenz von Markenlogos, Farben, Produktdarstellung und Charakterdesigns in allen Visuals sicherzustellen.',
        characterConsistencyAlt: 'Beispiel für Charakterkonsistenz',

        naturalLanguageTitle:
            'Angetrieben von Google Search für faktenbasierte Bilder',
        naturalLanguageDesc:
            'Nano Banana Pro kann sich mit Google Search verbinden, um Echtzeitinformationen abzurufen und genaue, überprüfbare Bilder zu generieren. Benötigen Sie ein Bild des heutigen Wetters in New York oder ein Diagramm der neuesten Aktienkurse? Es liefert präzise Ergebnisse und eignet sich ideal für Schulungsunterlagen, technische Anleitungen und Nachrichtenillustrationen.',
        naturalLanguageAlt: 'Beispiel für faktenbasiertes Bild',

        multiFusionTitle:
            'Native 4K-Ultraauflösung, Details, die jeder Prüfung standhalten',
        multiFusionDesc:
            'Nano Banana Pro kann Bilder in 1K, 2K und sogar 4K nativ generieren und bietet dabei beeindruckende Detailtiefe und Schärfe. Ob für Druck, große Digitalscreens oder Film-Postproduktion – es erfüllt die strengsten Anforderungen an die Bildqualität.',
        multiFusionAlt: 'Beispiel für ultra-hochauflösendes Bild',

        // Nutzung
        howToUseTitle: 'So verwenden Sie das Tool',
        howToUseSubtitle: 'In drei einfachen Schritten zum fertigen Bild',

        step1Title: 'Modell auswählen',
        step1Desc:
            'Wählen Sie in den KI-Bildtools das Modell Nano Banana Pro aus',

        step2Title: 'Inhalte eingeben',
        step2Desc:
            'Geben Sie Ihre Prompts ein oder laden Sie Referenzbilder hoch',

        step3Title: 'Bild generieren',
        step3Desc:
            'Klicken Sie auf die Schaltfläche „Generieren“, warten Sie kurz und laden Sie dann Ihr Bild herunter',

        // YouTube-Videos
        youtubeTitle: 'YouTube-Videos zum Nano Banana Pro KI-Bildmodell',

        // X-Posts
        xPostsTitle: 'X-Beiträge zum Nano Banana Pro KI-Bildmodell',

        // Weitere Modelle erkunden
        exploreTitle: 'Weitere KI-Bildmodelle auf 微鲤AI entdecken',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Bildgenerator',
        seedreamTitle: 'Seedream Bildgenerator',

        // FAQ-Bereich
        faqTitle: 'Häufig Gestellte Fragen',

        faq1Question: 'Was ist Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technisch als Gemini 3.0 Pro Image bekannt, ist Googles Flaggschiff-KI-Bildmodell der nächsten Generation. Im Gegensatz zu seinem Vorgänger führt es LLM-basierte "Tiefenargumentations"-Fähigkeiten ein, die es ermöglichen, logische Planung durchzuführen, bevor Bilder generiert werden. Es unterstützt native 4K-Auflösungsausgabe und verfügt über "Mehrschritt-Generierungs"-Fähigkeiten—das Modell überprüft selbst Skizzen, korrigiert Fehler und optimiert Details, wodurch beispiellose logische Konsistenz und physikalische Genauigkeit erreicht werden.',

        faq2Question: 'Warum Nano Banana Pro (Gemini 3.0 Pro Image) verwenden?',
        faq2Answer:
            'Nano Banana Pro ist die Top-Wahl für Creator, die extreme Details und Logik anstreben. Es generiert nicht nur Bilder—es "versteht" sie. Seine Kernvorteile umfassen: <br/>1. Argumentationsgesteuerte Synthese: Es versteht komplexe räumliche Beziehungen (wie "Brechung einer Katze hinter einem Glas") und rendert präzise Licht, Schatten und physikalische Interaktionen. <br/>2. Perfektes Text-Rendering: Es löst das Problem der KI-Rechtschreibschwierigkeiten vollständig und ermöglicht die präzise Generierung komplexer langer Texte, Marken und Typografie in Bildern. <br/>3. Nicht nur Bearbeitung, sondern Rekonstruktion: Beim Ändern von Bildern versteht es die dreidimensionale Struktur und ermöglicht es Ihnen, Objektwinkel oder Beleuchtung zu ändern, nicht nur Oberflächentexturen.',

        faq3Question:
            'Kann ich Google Nano Banana Pro (Gemini 3.0 Pro Image) kostenlos verwenden?',
        faq3Answer:
            'Ja. Sie können Nano Banana Pro (Gemini 3.0 Pro Image) kostenlos für die Bildgenerierung über 微鲤AI verwenden. Erstellen Sie einfach ein Konto, und unser kostenloser Testplan ermöglicht es Ihnen, alle Fähigkeiten dieses KI-Modells zu erleben, um schnell professionelle KI-Bilder zu generieren.',

        faq4Question:
            'Für welche Projekte eignet sich Google Nano Banana Pro (Gemini 3.0 Pro Image) am besten?',
        faq4Answer:
            'Aufgrund seiner leistungsstarken logischen Argumentation und 4K-Detailleistung ist Google Nano Banana Pro die perfekte Wahl für professionelle kommerzielle Anwendungen. Es ist besonders geeignet für: <br/>1. Komplexes Werbedesign: Kann Text und Beleuchtung auf Produkten präzise steuern. <br/>2. Langform-Visual-Storytelling: Behält absolute Konsistenz von Charakteren (Character Consistency) und Objektmerkmalen in verschiedenen Szenen, Winkeln und Beleuchtungen bei. <br/>3. UI/UX-Konzeptdesign: Kann direkt Anwendungsschnittstellen-Prototypen generieren, die lesbaren Text und korrekte Layouts enthalten.',

        faq5Question:
            'Welche künstlerischen Stile unterstützt der Google Nano Banana Pro Bildgenerator?',
        faq5Answer:
            'Nano Banana Pro durchbricht die Grenzen des Stils und zeichnet sich besonders in hyperrealistischer Fotografie (Hyper-realism) und komplexem 3D-Rendering aus. Zusätzlich zur Unterstützung traditioneller Stile wie Anime, Ölmalerei und Aquarell fügt es auch "logische Stilisierungs"-Fähigkeiten hinzu, die in der Lage sind, spezifische Filmbeleuchtung (wie Cyberpunk-Neon-Effekte, Dokumentarfilmstil mit natürlichem Licht) und präzise technische Zeichenstile nachzuahmen, wodurch sichergestellt wird, dass jedes Detail der Prüfung standhält.',

        // CTA-Bereich
        ctaTitle: 'Bereit, mit der Erstellung zu beginnen?',
        ctaDescription:
            'Probieren Sie jetzt Google Nano Banana Pro aus und verwandeln Sie Ihre Ideen in beeindruckende Bilder',
        ctaButton: 'Nano Banana Pro auf 微鲤AI testen',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        metaTitle: 'Генератор Изображений ИИ Nano Banana Pro ',
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) — это революционная модель генерации изображений ИИ, запущенная Google 20 ноября. Она вводит беспрецедентные возможности "глубокого рассуждения", позволяя ей не только рисовать, но и понимать физические законы и пространственную логику, достигая "сначала планировать, затем генерировать". Как флагманское обновление Nano Banana Pro, она поддерживает нативный вывод разрешения 4K и идеальные возможности рендеринга текста, может обрабатывать чрезвычайно сложные многошаговые инструкции и обеспечивать абсолютную согласованность персонажей в различных сценариях, что делает её идеальным инструментом для рекламного дизайна, визуального повествования и профессиональных создателей, стремящихся к экстремальным деталям.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, генерация изображений, рисование ИИ, искусственный интеллект, редактирование изображений, последовательность персонажей',
        generatorTitle: 'Генератор Изображений ИИ Google Nano Banana Pro',
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image) — первый в мире «движок рассуждающей графики», представленный Google. Он не только генерирует изображения, но и понимает физические законы и пространственную логику. Как флагманское обновление Nano Banana, он способен «обдумывать» и «планировать» сцену, как человек, создавая визуалы с беспрецедентной логической связностью, идеальной отрисовкой текста и ультра-высоким разрешением. Уже сейчас вы можете бесплатно протестировать Nano Banana Pro в генераторе изображений 微鲤AI.',

        // Основные возможности
        coreFeaturesTitle: 'Ключевые возможности Nano Banana Pro',
        coreFeaturesSubtitle:
            'Изучите ключевые возможности генератора изображений ИИ Google Nano Banana Pro и начните революционное путешествие в мире генерации изображений',

        // Функции
        soatTitle:
            'Идеальная отрисовка текста и готовые к использованию макеты',
        soatDesc:
            'Забудьте о кривом или нечитаемом тексте в изображениях ИИ. Для инфографики, меню, постеров или маркетинговых материалов Nano Banana Pro создаёт многоязычные, аккуратно сверстанные макеты, которые можно использовать сразу.',
        soatAlt: 'Пример отрисовки текста',

        characterConsistencyTitle:
            'Множественные референсы и фиксация персонажа для абсолютной согласованности',
        characterConsistencyDesc:
            'Nano Banana Pro поддерживает до 14 референсных изображений одновременно, что обеспечивает высокую согласованность логотипов, цветов, внешнего вида продукта и образа персонажа во всех ваших визуалах.',
        characterConsistencyAlt: 'Пример согласованности персонажа',

        naturalLanguageTitle:
            'Интеграция с Google Search для фактических изображений',
        naturalLanguageDesc:
            'Nano Banana Pro может подключаться к Google Search, получать актуальную информацию и генерировать точные, проверяемые изображения. Нужна картинка с сегодняшней погодой в Нью-Йорке или график последних котировок акций? Модель решит это с высокой точностью — идеальный инструмент для учебных материалов, технических руководств и новостных иллюстраций.',
        naturalLanguageAlt: 'Пример изображения на основе фактов',

        multiFusionTitle:
            'Нативное 4K‑разрешение и детали, выдерживающие любую проверку',
        multiFusionDesc:
            'Nano Banana Pro нативно генерирует изображения в 1K, 2K и даже 4K с поразительной детализацией и чёткостью. Подходит для полиграфии, больших цифровых экранов и кинопостпродакшна, удовлетворяя самые строгие требования к качеству изображения.',
        multiFusionAlt: 'Пример изображения ультра‑высокого разрешения',

        // Как использовать
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Начните творить всего за три простых шага',

        step1Title: 'Выберите модель',
        step1Desc:
            'В инструментах генерации изображений выберите модель Nano Banana Pro',

        step2Title: 'Введите содержимое',
        step2Desc:
            'Введите подсказки (prompt) или загрузите референсные изображения',

        step3Title: 'Сгенерируйте изображение',
        step3Desc:
            'Нажмите кнопку генерации, немного подождите и скачайте готовое изображение',

        // YouTube
        youtubeTitle:
            'Видео на YouTube о модели изображений ИИ Nano Banana Pro',

        // X (Twitter)
        xPostsTitle: 'Публикации в X о модели изображений ИИ Nano Banana Pro',

        // Исследовать другие модели
        exploreTitle:
            'Изучить другие модели генерации изображений ИИ на 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Генератор изображений Qwen',
        seedreamTitle: 'Генератор изображений Seedream',

        // Раздел FAQ
        faqTitle: 'Часто Задаваемые Вопросы',

        faq1Question: 'Что такое Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, технически известный как Gemini 3.0 Pro Image, — это флагманская модель изображений ИИ следующего поколения от Google. В отличие от своего предшественника, он вводит возможности "глубокого рассуждения" на основе LLM, позволяя выполнять логическое планирование перед генерацией изображений. Он поддерживает нативный вывод разрешения 4K и имеет возможности "многошаговой генерации": модель самостоятельно проверяет эскизы, исправляет ошибки и оптимизирует детали, достигая беспрецедентной логической согласованности и физической точности.',

        faq2Question:
            'Почему использовать Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro — лучший выбор для создателей, стремящихся к экстремальным деталям и логике. Он не просто генерирует изображения—он их "понимает". Его основные преимущества включают: <br/>1. Синтез, управляемый рассуждением: Он понимает сложные пространственные отношения (такие как "преломление кота за стеклом") и точно отображает свет, тень и физические взаимодействия. <br/>2. Идеальный рендеринг текста: Он полностью решает проблему трудностей с правописанием ИИ, позволяя точно генерировать сложные длинные тексты, торговые марки и типографику в изображениях. <br/>3. Не просто редактирование, а реконструкция: При изменении изображений он понимает трёхмерную структуру, позволяя изменять углы объектов или освещение, а не только поверхностные текстуры.',

        faq3Question:
            'Могу ли я бесплатно использовать Google Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq3Answer:
            'Да. Вы можете использовать Nano Banana Pro (Gemini 3.0 Pro Image) для бесплатной генерации изображений через 微鲤AI. Просто зарегистрируйте аккаунт, и наш бесплатный пробный план позволит вам испытать все возможности этой модели ИИ для быстрой генерации профессиональных изображений ИИ.',

        faq4Question:
            'Для каких проектов лучше всего подходит Google Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq4Answer:
            'Благодаря мощному логическому рассуждению и производительности деталей 4K, Google Nano Banana Pro — идеальный выбор для профессиональных коммерческих приложений. Он особенно подходит для: <br/>1. Сложного рекламного дизайна: Может точно контролировать текст и освещение на продуктах. <br/>2. Длинного визуального повествования: Поддерживает абсолютную согласованность персонажей (Character Consistency) и характеристик объектов в различных сценах, углах и освещении. <br/>3. Концептуального дизайна UI/UX: Может напрямую генерировать прототипы интерфейсов приложений, содержащие читаемый текст и правильные макеты.',

        faq5Question:
            'Какие художественные стили поддерживает генератор изображений Google Nano Banana Pro?',
        faq5Answer:
            'Nano Banana Pro раздвигает границы стиля, особенно преуспевая в гиперреалистической фотографии (Hyper-realism) и сложном 3D-рендеринге. Помимо поддержки традиционных стилей, таких как аниме, масляная живопись и акварель, он также добавляет возможности "логической стилизации", способные имитировать специфическое кинематографическое освещение (такое как эффекты неона в стиле киберпанк, документальный стиль естественного света) и точные стили технического черчения, обеспечивая, чтобы каждая деталь выдерживала проверку.',

        // CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription:
            'Попробуйте Google Nano Banana Pro уже сейчас и превратите свои идеи в впечатляющие изображения',
        ctaButton: 'Попробовать Nano Banana Pro на 微鲤AI',
        ctaDisclaimer: 'Банковская карта не требуется',
    },
    pt: {
        metaTitle: 'Gerador de Imagens IA Nano Banana Pro ',
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) é um modelo revolucionário de geração de imagens IA lançado pelo Google em 20 de novembro. Ele introduz capacidades de "raciocínio profundo" sem precedentes, permitindo não apenas pintar, mas também entender as leis físicas e a lógica espacial, alcançando "planejar primeiro, depois gerar". Como atualização principal do Nano Banana Pro, suporta saída de resolução 4K nativa e capacidades perfeitas de renderização de texto, pode lidar com instruções de múltiplas etapas extremamente complexas e garantir consistência absoluta de personagens em diferentes cenários, tornando-o a ferramenta definitiva para design publicitário, narrativa visual e criadores profissionais que buscam detalhes extremos.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, geração de imagens, pintura IA, inteligência artificial, edição de imagens, consistência de personagens',
        generatorTitle: 'Gerador de Imagens IA Google Nano Banana Pro',
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image) é o primeiro "motor de imagens por raciocínio" do mundo lançado pelo Google. Ele não apenas gera imagens, mas também entende leis físicas e lógica espacial. Como atualização principal do Nano Banana, consegue "pensar" e "planejar" cenas como um humano, criando visuais com consistência lógica sem precedentes, texto perfeitamente renderizado e resolução ultra-alta. Agora você pode testar o Nano Banana Pro gratuitamente no gerador de imagens da 微鲤AI.',

        // Recursos principais
        coreFeaturesTitle: 'Recursos principais do Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore os recursos centrais do gerador de imagens IA Google Nano Banana Pro e inicie uma jornada revolucionária de criação de imagens com IA',

        // Funcionalidades
        soatTitle: 'Renderização de texto perfeita, layouts prontos para uso',
        soatDesc:
            'Diga adeus ao texto distorcido ou ilegível em imagens geradas por IA. Para infográficos, menus, cartazes ou materiais de marketing, o Nano Banana Pro gera composições tipográficas multilíngues prontas para uso imediato.',
        soatAlt: 'Exemplo de renderização de texto',

        characterConsistencyTitle:
            'Múltiplas referências e bloqueio de personagem para consistência absoluta',
        characterConsistencyDesc:
            'O Nano Banana Pro suporta até 14 imagens de referência simultâneas para orientar a criação, garantindo alta consistência de logotipos de marca, cores, aparência de produtos e identidade de personagens em todos os seus visuais.',
        characterConsistencyAlt: 'Exemplo de consistência de personagem',

        naturalLanguageTitle:
            'Impulsionado pelo Google Search para imagens baseadas em fatos',
        naturalLanguageDesc:
            'O Nano Banana Pro pode se conectar ao Google Search para obter informações em tempo real e gerar imagens precisas e verificáveis. Precisa de uma imagem com o clima de hoje em Nova York ou um gráfico com as cotações mais recentes? Ele resolve isso com precisão, sendo ideal para manuais de treinamento, guias técnicos e ilustrações de notícias.',
        naturalLanguageAlt: 'Exemplo de imagem baseada em fatos',

        multiFusionTitle:
            'Resolução 4K nativa, detalhes que suportam qualquer inspeção',
        multiFusionDesc:
            'O Nano Banana Pro gera nativamente imagens em 1K, 2K e até 4K com um nível impressionante de detalhe e nitidez. Seja para impressão, telas digitais de grande formato ou pós-produção de vídeo, ele atende aos requisitos de qualidade de imagem mais exigentes.',
        multiFusionAlt: 'Exemplo de imagem em ultra-alta resolução',

        // Como usar
        howToUseTitle: 'Como usar',
        howToUseSubtitle: 'Comece a criar em três etapas simples',

        step1Title: 'Selecionar o modelo',
        step1Desc:
            'Nas ferramentas de imagem com IA, selecione o modelo Nano Banana Pro',

        step2Title: 'Inserir o conteúdo',
        step2Desc: 'Digite seus prompts ou envie imagens de referência',

        step3Title: 'Gerar a imagem',
        step3Desc:
            'Clique no botão de gerar, aguarde alguns instantes e faça o download da imagem',

        // YouTube
        youtubeTitle:
            'Vídeos do YouTube sobre o modelo de imagem IA Nano Banana Pro',

        // X
        xPostsTitle:
            'Publicações no X sobre o modelo de imagem IA Nano Banana Pro',

        // Explorar outros modelos
        exploreTitle: 'Explore outros modelos de imagem com IA na 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Gerador de Imagens Qwen',
        seedreamTitle: 'Gerador de Imagens Seedream',

        // FAQ
        faqTitle: 'Perguntas Frequentes',

        faq1Question: 'O que é Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, tecnicamente conhecido como Gemini 3.0 Pro Image, é o modelo de imagens IA principal de próxima geração do Google. Diferente de seu predecessor, ele introduz capacidades de "raciocínio profundo" baseadas em LLM, permitindo realizar planejamento lógico antes de gerar imagens. Ele suporta saída de resolução 4K nativa e possui capacidades de "geração multi-etapas": o modelo auto-revisa esboços, corrige erros e otimiza detalhes, alcançando consistência lógica e precisão física sem precedentes.',

        faq2Question: 'Por que usar Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro é a melhor escolha para criadores que buscam detalhes extremos e lógica. Ele não apenas gera imagens—ele as "entende". Suas vantagens principais incluem: <br/>1. Síntese guiada por raciocínio: Ele entende relações espaciais complexas (como "refração de um gato atrás de um copo") e renderiza com precisão luz, sombra e interações físicas. <br/>2. Renderização de texto perfeita: Ele resolve completamente o problema de dificuldade de ortografia de IA, permitindo a geração precisa de texto longo complexo, marcas comerciais e tipografia em imagens. <br/>3. Não apenas edição, mas reconstrução: Ao modificar imagens, ele entende a estrutura tridimensional, permitindo alterar ângulos ou iluminação de objetos, não apenas texturas superficiais.',

        faq3Question:
            'Posso usar Google Nano Banana Pro (Gemini 3.0 Pro Image) gratuitamente?',
        faq3Answer:
            'Sim. Você pode usar Nano Banana Pro (Gemini 3.0 Pro Image) para geração de imagens gratuita através do 微鲤AI. Basta registrar uma conta, e nosso plano de teste gratuito permite que você experimente todas as capacidades deste modelo IA para gerar rapidamente imagens IA de nível profissional.',

        faq4Question:
            'Para quais projetos o Google Nano Banana Pro (Gemini 3.0 Pro Image) é mais adequado?',
        faq4Answer:
            'Devido ao seu poderoso raciocínio lógico e desempenho de detalhes 4K, o Google Nano Banana Pro é a escolha perfeita para aplicações comerciais profissionais. É particularmente adequado para: <br/>1. Design publicitário complexo: Pode controlar com precisão texto e iluminação em produtos. <br/>2. Narrativa visual de longa duração: Mantém consistência absoluta de personagens (Character Consistency) e características de objetos em diferentes cenas, ângulos e iluminação. <br/>3. Design de conceito UI/UX: Pode gerar diretamente protótipos de interface de aplicativo contendo texto legível e layouts corretos.',

        faq5Question:
            'Quais estilos artísticos o gerador de imagens Google Nano Banana Pro suporta?',
        faq5Answer:
            'Nano Banana Pro quebra os limites do estilo, destacando-se particularmente em fotografia hiper-realista (Hyper-realism) e renderização 3D complexa. Além de suportar estilos tradicionais como anime, pintura a óleo e aquarela, ele também adiciona capacidades de "estilização lógica", capaz de imitar iluminação cinematográfica específica (como efeitos de néon cyberpunk, estilo documentário de luz natural) e estilos de desenho técnico precisos, garantindo que cada detalhe resista ao escrutínio.',

        // CTA
        ctaTitle: 'Pronto para começar a criar?',
        ctaDescription:
            'Experimente agora o Google Nano Banana Pro e transforme suas ideias em imagens incríveis',
        ctaButton: 'Experimentar Nano Banana Pro na 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        metaTitle: 'Generatore di Immagini IA Nano Banana Pro ',
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) è un modello rivoluzionario di generazione di immagini IA lanciato da Google il 20 novembre. Introduce capacità di "ragionamento profondo" senza precedenti, permettendogli non solo di dipingere, ma anche di comprendere le leggi fisiche e la logica spaziale, raggiungendo "pianificare prima, poi generare". Come aggiornamento principale di Nano Banana Pro, supporta l\'output di risoluzione 4K nativa e capacità perfette di rendering del testo, può gestire istruzioni multi-step estremamente complesse e garantire la coerenza assoluta dei personaggi in diversi scenari, rendendolo lo strumento definitivo per il design pubblicitario, la narrazione visiva e i creatori professionali che cercano dettagli estremi.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, generazione immagini, pittura IA, intelligenza artificiale, modifica immagini, coerenza personaggi',
        generatorTitle: 'Generatore di Immagini IA Google Nano Banana Pro',
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image) è il primo "motore di immagini basato sul ragionamento" al mondo lanciato da Google. Non si limita a generare immagini, ma comprende anche le leggi fisiche e la logica spaziale. Come aggiornamento di punta di Nano Banana, è in grado di "pensare" e "pianificare" le scene come un essere umano, creando visual con una coerenza logica senza precedenti, un rendering del testo perfetto e un\'ultra alta risoluzione. Puoi provare Nano Banana Pro gratuitamente nel generatore di immagini 微鲤AI.',

        // Funzionalità principali
        coreFeaturesTitle: 'Funzionalità chiave di Nano Banana Pro',
        coreFeaturesSubtitle:
            'Esplora le funzionalità principali del generatore di immagini IA Google Nano Banana Pro e inizia un viaggio rivoluzionario nella creazione di immagini con IA',

        // Funzioni
        soatTitle: 'Rendering del testo perfetto, layout pronti all’uso',
        soatDesc:
            'Dì addio per sempre al testo distorto o illeggibile nelle immagini generate dall’IA. Per infografiche, menu, poster o materiali di marketing, Nano Banana Pro genera composizioni tipografiche multilingue pronte per essere utilizzate subito.',
        soatAlt: 'Esempio di rendering del testo',

        characterConsistencyTitle:
            'Riferimenti multipli e blocco del personaggio per una coerenza assoluta',
        characterConsistencyDesc:
            'Nano Banana Pro supporta fino a 14 immagini di riferimento simultanee per guidare la creazione, garantendo un’elevata coerenza di loghi di marca, colori, aspetto dei prodotti e identità dei personaggi in tutti i tuoi visual.',
        characterConsistencyAlt: 'Esempio di coerenza del personaggio',

        naturalLanguageTitle:
            'Supportato da Google Search per immagini basate sui fatti',
        naturalLanguageDesc:
            'Nano Banana Pro può collegarsi a Google Search per ottenere informazioni in tempo reale e generare immagini accurate e verificabili. Ti serve un’immagine del meteo di oggi a New York o un grafico con le ultime quotazioni di borsa? Lo gestisce con precisione, ideale per manuali di formazione, guide tecniche e illustrazioni di notizie.',
        naturalLanguageAlt: 'Esempio di immagine basata sui fatti',

        multiFusionTitle:
            'Risoluzione 4K nativa, dettagli che resistono a ogni esame',
        multiFusionDesc:
            'Nano Banana Pro genera in modo nativo immagini in 1K, 2K e persino 4K con un livello di dettaglio e nitidezza sorprendente. Che si tratti di stampa, maxischermi digitali o post-produzione video, soddisfa i requisiti di qualità dell’immagine più elevati.',
        multiFusionAlt: 'Esempio di immagine in ultra alta risoluzione',

        // Come usare
        howToUseTitle: 'Come usarlo',
        howToUseSubtitle: 'Inizia a creare in tre semplici passaggi',

        step1Title: 'Seleziona il modello',
        step1Desc:
            'Negli strumenti di immagine IA, seleziona il modello Nano Banana Pro',

        step2Title: 'Inserisci i contenuti',
        step2Desc: 'Inserisci i prompt o carica immagini di riferimento',

        step3Title: 'Genera l’immagine',
        step3Desc:
            'Clicca sul pulsante di generazione, attendi qualche istante e scarica l’immagine',

        // YouTube
        youtubeTitle:
            'Video YouTube sul modello di immagini IA Nano Banana Pro',

        // X
        xPostsTitle: 'Post su X sul modello di immagini IA Nano Banana Pro',

        // Esplora altri modelli
        exploreTitle: 'Esplora altri modelli di immagini IA su 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Generatore di Immagini Qwen',
        seedreamTitle: 'Generatore di Immagini Seedream',

        // FAQ
        faqTitle: 'Domande Frequenti',

        faq1Question: "Cos'è Google Nano Banana Pro?",
        faq1Answer:
            'Nano Banana Pro, tecnicamente noto come Gemini 3.0 Pro Image, è il modello di immagini IA principale di prossima generazione di Google. A differenza del suo predecessore, introduce capacità di "ragionamento profondo" basate su LLM, permettendogli di eseguire pianificazione logica prima di generare immagini. Supporta l\'output di risoluzione 4K nativa e possiede capacità di "generazione multi-step": il modello auto-revisiona schizzi, corregge errori e ottimizza dettagli, raggiungendo coerenza logica e precisione fisica senza precedenti.',

        faq2Question: 'Perché usare Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro è la scelta migliore per i creatori che cercano dettagli estremi e logica. Non genera solo immagini—le "comprende". I suoi vantaggi principali includono: <br/>1. Sintesi guidata dal ragionamento: Comprende relazioni spaziali complesse (come "rifrazione di un gatto dietro un bicchiere") e renderizza con precisione luce, ombra e interazioni fisiche. <br/>2. Rendering del testo perfetto: Risolve completamente il problema della difficoltà di ortografia dell\'IA, permettendo la generazione precisa di testo lungo complesso, marchi commerciali e tipografia nelle immagini. <br/>3. Non solo modifica, ma ricostruzione: Quando modifica immagini, comprende la struttura tridimensionale, permettendoti di cambiare angoli o illuminazione degli oggetti, non solo texture superficiali.',

        faq3Question:
            'Posso usare Google Nano Banana Pro (Gemini 3.0 Pro Image) gratuitamente?',
        faq3Answer:
            'Sì. Puoi usare Nano Banana Pro (Gemini 3.0 Pro Image) per la generazione di immagini gratuita tramite 微鲤AI. Basta registrare un account, e il nostro piano di prova gratuito ti permette di sperimentare tutte le capacità di questo modello IA per generare rapidamente immagini IA di livello professionale.',

        faq4Question:
            'Per quali progetti Google Nano Banana Pro (Gemini 3.0 Pro Image) è più adatto?',
        faq4Answer:
            'A causa del suo potente ragionamento logico e delle prestazioni di dettagli 4K, Google Nano Banana Pro è la scelta perfetta per applicazioni commerciali professionali. È particolarmente adatto per: <br/>1. Design pubblicitario complesso: Può controllare con precisione testo e illuminazione sui prodotti. <br/>2. Narrazione visiva di lunga durata: Mantiene coerenza assoluta di personaggi (Character Consistency) e caratteristiche di oggetti in diverse scene, angoli e illuminazione. <br/>3. Design di concetto UI/UX: Può generare direttamente prototipi di interfaccia applicativa contenenti testo leggibile e layout corretti.',

        faq5Question:
            'Quali stili artistici supporta il generatore di immagini Google Nano Banana Pro?',
        faq5Answer:
            'Nano Banana Pro rompe i confini dello stile, eccellendo particolarmente in fotografia iperrealistica (Hyper-realism) e rendering 3D complesso. Oltre a supportare stili tradizionali come anime, pittura ad olio e acquerello, aggiunge anche capacità di "stilizzazione logica", in grado di imitare illuminazione cinematografica specifica (come effetti neon cyberpunk, stile documentario a luce naturale) e stili di disegno tecnico precisi, garantendo che ogni dettaglio resista allo scrutinio.',

        // CTA
        ctaTitle: 'Pronto per iniziare a creare?',
        ctaDescription:
            'Prova subito Google Nano Banana Pro e trasforma le tue idee in immagini straordinarie',
        ctaButton: 'Prova Nano Banana Pro su 微鲤AI',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',
    },
    ar: {
        metaTitle: 'مولد صور الذكاء الاصطناعي Nano Banana Pro ',
        metaDescription:
            'Google Nano Banana Pro (Gemini 3.0 Pro Image) هو نموذج ثوري لتوليد الصور بالذكاء الاصطناعي أطلقه Google في 20 نوفمبر. يقدم قدرات "الاستدلال العميق" غير المسبوقة، مما يسمح له ليس فقط بالرسم، بل أيضًا بفهم القوانين الفيزيائية والمنطق المكاني، محققًا "التخطيط أولاً، ثم التوليد". كترقية رئيسية لـ Nano Banana، يدعم إخراج دقة 4K الأصلية وقدرات عرض النص المثالية، ويمكنه التعامل مع التعليمات متعددة الخطوات المعقدة للغاية وضمان تناسق الشخصيات المطلق في سيناريوهات مختلفة، مما يجعله الأداة النهائية لتصميم الإعلانات والسرد البصري والمبدعين المحترفين الذين يسعون للحصول على تفاصيل متطرفة.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, توليد الصور, رسم بالذكاء الاصطناعي, الذكاء الاصطناعي, تحرير الصور, تناسق الشخصيات',
        generatorTitle: 'مولد صور الذكاء الاصطناعي Google Nano Banana Pro',
        generatorSubtitle:
            'Nano Banana Pro (Gemini 3.0 Pro Image) هو أول "محرك صور قائم على الاستدلال" في العالم أطلقته Google. لا يقتصر دوره على توليد الصور فحسب، بل يفهم أيضًا القوانين الفيزيائية والمنطق المكاني. باعتباره الترقية الرئيسية لـ Nano Banana، يمكنه "التفكير" و"تخطيط" المشاهد مثل الإنسان، وينتج صورًا ذات اتساق منطقي غير مسبوق ونصوص واضحة بدقة ودقة 4K فائقة. يمكنك الآن تجربة Nano Banana Pro مجانًا من خلال مولد الصور 微鲤AI.',

        // المزايا الأساسية
        coreFeaturesTitle: 'الميزات الأساسية لـ Nano Banana Pro',
        coreFeaturesSubtitle:
            'استكشف الميزات الأساسية لمولد الصور بالذكاء الاصطناعي Google Nano Banana Pro وابدأ رحلة ثورية في إنشاء الصور بالذكاء الاصطناعي',

        // الوظائف
        soatTitle: 'عرض نص مثالي وتصميمات جاهزة للاستخدام',
        soatDesc:
            'ودّع تشوه النصوص أو صعوبة قراءتها في الصور المُولدة بالذكاء الاصطناعي. سواء كنت تنشئ مخططات معلوماتية أو قوائم طعام أو ملصقات أو مواد تسويقية، يقوم Nano Banana Pro بإنشاء تصميمات منسقة متعددة اللغات جاهزة للاستخدام المباشر.',
        soatAlt: 'مثال على عرض النص',

        characterConsistencyTitle: 'مراجع متعددة وقفل للشخصية لضمان تناسق مطلق',
        characterConsistencyDesc:
            'يدعم Nano Banana Pro ما يصل إلى 14 صورة مرجعية في وقت واحد لتوجيه عملية الإنشاء، مما يضمن تناسقًا عاليًا في شعارات العلامة التجارية والألوان ومظهر المنتج وهوية الشخصيات في جميع أعمالك البصرية.',
        characterConsistencyAlt: 'مثال على تناسق الشخصية',

        naturalLanguageTitle:
            'مدعوم من بحث Google لإنشاء صور مبنية على الحقائق',
        naturalLanguageDesc:
            'يمكن لـ Nano Banana Pro الاتصال ببحث Google لجلب معلومات فورية وإنشاء صور دقيقة وقابلة للتحقق. هل تحتاج إلى صورة لطقس اليوم في نيويورك أو مخطط يوضح أحدث أسعار الأسهم؟ يقوم بذلك بدقة، مما يجعله مثاليًا لأدلة التدريب والوثائق التقنية والرسومات الإخبارية.',
        naturalLanguageAlt: 'مثال على صورة مبنية على الحقائق',

        multiFusionTitle: 'دقة 4K أصلية وتفاصيل تتحمل أدق الفحوصات',
        multiFusionDesc:
            'يمكن لـ Nano Banana Pro إنشاء صور بدقة 1K و2K وحتى 4K أصلية مع مستوى مذهل من التفاصيل والوضوح. سواء للاستخدام في الطباعة أو الشاشات الرقمية الكبيرة أو مرحلة ما بعد الإنتاج للفيديو، فإنه يفي بأعلى متطلبات جودة الصورة.',
        multiFusionAlt: 'مثال على صورة فائقة الدقة',

        // كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ابدأ الإبداع في ثلاث خطوات بسيطة',

        step1Title: 'اختر النموذج',
        step1Desc: 'في أدوات صور الذكاء الاصطناعي، اختر نموذج Nano Banana Pro',

        step2Title: 'أدخل المحتوى',
        step2Desc: 'اكتب المطالبات (Prompts) أو قم برفع صور مرجعية',

        step3Title: 'قم بإنشاء الصورة',
        step3Desc: 'اضغط على زر الإنشاء، انتظر قليلاً ثم قم بتحميل صورتك',

        // قسم يوتيوب
        youtubeTitle:
            'مقاطع فيديو YouTube حول نموذج صور الذكاء الاصطناعي Nano Banana Pro',

        // قسم X
        xPostsTitle: 'منشورات X حول نموذج صور الذكاء الاصطناعي Nano Banana Pro',

        // استكشاف النماذج الأخرى
        exploreTitle: 'استكشف نماذج صور ذكاء اصطناعي أخرى على 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'مولد صور Qwen',
        seedreamTitle: 'مولد صور Seedream',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',

        faq1Question: 'ما هو Google Nano Banana Pro؟',
        faq1Answer:
            'Nano Banana Pro، المعروف تقنيًا باسم Gemini 3.0 Pro Image، هو نموذج الصور بالذكاء الاصطناعي الرئيسي من الجيل التالي من Google. على عكس سابقه، يقدم قدرات "الاستدلال العميق" القائمة على LLM، مما يسمح له بإجراء التخطيط المنطقي قبل توليد الصور. يدعم إخراج دقة 4K الأصلية ويمتلك قدرات "التوليد متعدد الخطوات": يقوم النموذج بمراجعة الرسومات التخطيطية تلقائيًا، وتصحيح الأخطاء، وتحسين التفاصيل، محققًا اتساقًا منطقيًا ودقة فيزيائية غير مسبوقة.',

        faq2Question: 'لماذا استخدام Nano Banana Pro (Gemini 3.0 Pro Image)؟',
        faq2Answer:
            'Nano Banana Pro هو الخيار الأمثل للمبدعين الذين يسعون للحصول على تفاصيل متطرفة ومنطق. لا يولد الصور فحسب—بل "يفهمها". تشمل مزاياها الأساسية: <br/>1. التركيب الموجه بالاستدلال: يفهم العلاقات المكانية المعقدة (مثل "انكسار قطة خلف كوب") ويعرض بدقة الضوء والظل والتفاعلات الفيزيائية. <br/>2. عرض النص المثالي: يحل تمامًا مشكلة صعوبة الإملاء في الذكاء الاصطناعي، مما يسمح بتوليد دقيق للنصوص الطويلة المعقدة والعلامات التجارية والطباعة في الصور. <br/>3. ليس فقط التحرير، بل إعادة البناء: عند تعديل الصور، يفهم البنية ثلاثية الأبعاد، مما يسمح لك بتغيير زوايا الكائنات أو الإضاءة، وليس فقط القوام السطحي.',

        faq3Question:
            'هل يمكنني استخدام Google Nano Banana Pro (Gemini 3.0 Pro Image) مجانًا؟',
        faq3Answer:
            'نعم. يمكنك استخدام Nano Banana Pro (Gemini 3.0 Pro Image) لتوليد الصور مجانًا من خلال 微鲤AI. ما عليك سوى التسجيل للحصول على حساب، وتتيح لك خطة التجربة المجانية تجربة جميع قدرات نموذج الذكاء الاصطناعي هذا لتوليد صور ذكاء اصطناعي احترافية بسرعة.',

        faq4Question:
            'ما هي المشاريع الأنسب لـ Google Nano Banana Pro (Gemini 3.0 Pro Image)؟',
        faq4Answer:
            'نظرًا لاستدلاله المنطقي القوي وأداء التفاصيل بدقة 4K، فإن Google Nano Banana Pro هو الخيار المثالي للتطبيقات التجارية الاحترافية. وهو مناسب بشكل خاص لـ: <br/>1. تصميم الإعلانات المعقد: يمكنه التحكم بدقة في النص والإضاءة على المنتجات. <br/>2. السرد البصري طويل الشكل: يحافظ على تناسق مطلق للشخصيات (Character Consistency) وخصائص الكائنات في مشاهد وزوايا وإضاءة مختلفة. <br/>3. تصميم مفهوم UI/UX: يمكنه توليد نماذج أولية لواجهة التطبيق مباشرة تحتوي على نص قابل للقراءة وتخطيطات صحيحة.',

        faq5Question:
            'ما هي الأنماط الفنية التي يدعمها مولد صور Google Nano Banana Pro؟',
        faq5Answer:
            'يكسر Nano Banana Pro حدود النمط، متفوقًا بشكل خاص في التصوير الفوتوغرافي فائق الواقعية (Hyper-realism) وعرض 3D المعقد. بالإضافة إلى دعم الأنماط التقليدية مثل الأنيمي والرسم الزيتي والألوان المائية، يضيف أيضًا قدرات "التصميم المنطقي"، قادرًا على محاكاة الإضاءة السينمائية المحددة (مثل تأثيرات النيون السايبربانك، نمط الوثائقي بالضوء الطبيعي) وأنماط الرسم التقني الدقيقة، مما يضمن أن كل تفصيل يتحمل التدقيق.',

        // قسم الدعوة إلى الإجراء
        ctaTitle: 'هل أنت مستعد لبدء الإبداع؟',
        ctaDescription:
            'جرّب Google Nano Banana Pro الآن وحوّل أفكارك إلى صور مدهشة',
        ctaButton: 'جرّب Nano Banana Pro على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    da: { // Danish (copied from English)
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        metaTitle: 'Nano Banana Pro AI Image Generator ',
        metaDescription:
            'Nano Banana Pro (Gemini 3.0 Pro Image) is the world’s first "reasoning image engine" launched by Google. It not only generates images, but also understands physical laws and spatial logic. As the flagship upgrade of Nano Banana, it can "think" and "plan" scenes like a human, creating visuals with unprecedented logical consistency, perfect text rendering, and ultra‑high resolution. You can now try Nano Banana Pro for free in the 微鲤AI image generator.',
        metaKeywords:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Generator Section
        generatorTitle: 'Google Nano Banana Pro AI Image Generator',
        generatorSubtitle:
            'Nano Banana Pro, Gemini 3.0 Pro Image, Google AI, image generation, AI art, artificial intelligence, image editing, character consistency',

        // Core Features Section
        coreFeaturesTitle: 'Core Features of Nano Banana Pro',
        coreFeaturesSubtitle:
            'Explore the core capabilities of the Google Nano Banana Pro AI image generator and start a revolutionary AI image creation journey',

        // Features
        soatTitle: 'Perfect Text Rendering, Ready-to-Use Design Drafts',
        soatDesc:
            'Say goodbye to distorted or broken text in AI images. Whether you are creating infographics, menus, posters, or marketing materials, Nano Banana Pro generates beautifully typeset, multi-language layouts that are ready to use directly.',
        soatAlt: 'Text rendering image example',

        characterConsistencyTitle:
            'Multi-Image Reference and Character Lock for Absolute Consistency',
        characterConsistencyDesc:
            'Nano Banana Pro supports using up to 14 reference images at the same time to guide creation, ensuring highly consistent brand logos, colors, product appearance, and character identity across all your visuals.',
        characterConsistencyAlt: 'Character consistency image example',

        naturalLanguageTitle: 'Powered by Google Search for Fact-Based Images',
        naturalLanguageDesc:
            'Nano Banana Pro can connect to Google Search to fetch real-time information and generate accurate, verifiable images. Need a picture of today’s weather in New York, or a chart showing the latest stock prices? It handles these precisely, making it perfect for training manuals, technical guides, and news illustrations.',
        naturalLanguageAlt: 'Fact-based image example',

        multiFusionTitle:
            'Native 4K Ultra-High Resolution, Detail that Holds Up',
        multiFusionDesc:
            'Nano Banana Pro can natively generate 1K, 2K, and even 4K ultra-high-resolution images with stunning levels of detail and clarity. Whether for print, digital billboards, or film post-production, it meets the most demanding image quality requirements.',
        multiFusionAlt: 'Ultra-high-resolution image example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Start creating in three simple steps',

        step1Title: 'Select the Model',
        step1Desc: 'In the AI image tools, choose the Nano Banana Pro model',

        step2Title: 'Input Your Content',
        step2Desc: 'Enter prompts or upload reference images',

        step3Title: 'Generate Your Image',
        step3Desc:
            'Click the generate button, then wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube videos about the Nano Banana Pro AI image model',

        // X Posts Section
        xPostsTitle: 'X posts about the Nano Banana Pro AI image model',

        // Explore Other Models Section
        exploreTitle: 'Explore other AI image models on 微鲤AI',
        imagenTitle: 'Google Nano Banana',
        qwenTitle: 'Qwen Image Generator',
        seedreamTitle: 'Seedream Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Google Nano Banana Pro?',
        faq1Answer:
            'Nano Banana Pro, technically known as Gemini 3.0 Pro Image, is Google\'s next-generation flagship AI image model. Unlike its predecessor, it introduces LLM-based "deep reasoning" capabilities, enabling it to perform logical planning before generating images. It supports native 4K resolution output and features "multi-step generation" capabilities—the model self-reviews sketches, corrects errors, and optimizes details, achieving unprecedented logical consistency and physical accuracy.',

        faq2Question: 'Why use Nano Banana Pro (Gemini 3.0 Pro Image)?',
        faq2Answer:
            'Nano Banana Pro is the top choice for creators pursuing extreme detail and logic. It doesn\'t just generate images—it "understands" them. Its core advantages include: <br/>1. Reasoning-guided synthesis: It understands complex spatial relationships (such as "refraction of a cat behind a glass") and accurately renders light, shadow, and physical interactions. <br/>2. Perfect text rendering: It completely solves the AI spelling difficulty problem, enabling precise generation of complex long text, trademarks, and typography in images. <br/>3. Not just editing, but reconstruction: When modifying images, it understands three-dimensional structure, allowing you to change object angles or lighting, not just surface textures.',

        faq3Question:
            'Can I use Google Nano Banana Pro (Gemini 3.0 Pro Image) for free?',
        faq3Answer:
            'Yes. You can use Nano Banana Pro (Gemini 3.0 Pro Image) for free image generation through 微鲤AI. Simply register an account, and our free trial plan lets you experience the full capabilities of this AI model to quickly generate professional-grade AI images.',

        faq4Question:
            'What projects is Google Nano Banana Pro (Gemini 3.0 Pro Image) best suited for?',
        faq4Answer:
            'Due to its powerful logical reasoning and 4K detail performance, Google Nano Banana Pro is the perfect choice for professional commercial applications. It is particularly suitable for: <br/>1. Complex advertising design: Can precisely control text and lighting on products. <br/>2. Long-form visual storytelling: Maintains absolute consistency of characters (Character Consistency) and object features across different scenes, angles, and lighting. <br/>3. UI/UX concept design: Can directly generate application interface prototypes containing readable text and correct layouts.',

        faq5Question:
            'What artistic styles does the Google Nano Banana Pro image generator support?',
        faq5Answer:
            'Nano Banana Pro breaks the boundaries of style, excelling particularly in hyper-realistic photography (Hyper-realism) and complex 3D rendering. In addition to supporting traditional styles such as anime, oil painting, and watercolor, it also adds "logical stylization" capabilities, able to mimic specific cinematic lighting (such as cyberpunk neon effects, natural light documentary style) and precise technical drawing styles, ensuring every detail stands up to scrutiny.',

        // CTA Section
        ctaTitle: 'Ready to start creating?',
        ctaDescription:
            'Experience Google Nano Banana Pro now and transform your ideas into stunning images',
        ctaButton: 'Try Nano Banana Pro on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
}
